import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=18aba850&"
import script from "./Table.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Table.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports